import { useState } from 'react'

import { SplitButton } from 'components/common'
import { InvoiceButtonIdsList, InvoiceButtonsId } from 'constants/EntityConstants'
import { GetFileName, SaveFile, ShowRestError } from 'helpers'
import { DownloadAccountPayableInvoiceReport } from 'services'

import SendToDialog from './SendToDialog'

interface InvoiceActionsProps {
  accountPayableRecordId: number
}

function InvoiceActions({ accountPayableRecordId }: InvoiceActionsProps) {
  const [isProcessing, setIsProcessing] = useState(false)

  const [isSendToDialogOpen, setSendToDialogOpen] = useState<boolean>(false)

  // Handlers
  const openSendToDialog = () => {
    setSendToDialogOpen(true)
  }

  const closeSendToDialog = () => {
    setSendToDialogOpen(false)
  }

  const handleDowlandInvoice = () => {
    setIsProcessing(true)

    DownloadAccountPayableInvoiceReport(accountPayableRecordId)
      .then((response) => {
        setIsProcessing(false)
        const fileName =
          GetFileName(response) ?? `account-payable-invoice-report-${accountPayableRecordId}.pdf`

        SaveFile(response.data, fileName)
      })
      .catch(ShowRestError)
      .finally(() => {
        setIsProcessing(false)
      })
  }

  const handleClick = (buttonId: InvoiceButtonsId) => {
    switch (buttonId) {
      case InvoiceButtonsId.Download:
        handleDowlandInvoice()
        break

      case InvoiceButtonsId.SendToEmail:
        openSendToDialog()
        break
    }
  }

  return (
    <>
      <SplitButton
        loading={isProcessing}
        disabled={isProcessing}
        options={InvoiceButtonIdsList}
        onButtonClick={handleClick}
      />
      <SendToDialog
        isOpen={isSendToDialogOpen}
        onClose={closeSendToDialog}
        accountPayableRecordId={accountPayableRecordId}
      />
    </>
  )
}
export default InvoiceActions
